import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './style.css';

const TooltipComponent = (props) => {
  function renderTooltip(tooltipProps) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Tooltip id='button-tooltip' {...tooltipProps}>
        {props.tooltipContent}
      </Tooltip>
    );
  }
  return (
    <OverlayTrigger
      placement={props.placement}
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <FontAwesomeIcon className='questionsCircle' icon={props.icon} />
    </OverlayTrigger>
  );
};

export default React.memo(TooltipComponent);
